import { Rect, Size } from "PosterEditor/model/poster-types";

export const rectWithPadding = (rect: Rect, padding: number): Rect => {
  return {
    x: rect.x - padding,
    y: rect.y - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
};

export const aspectFitSize = (size: Size, target: Size): Size => {
  const targetAspectRatio = target.width / target.height;
  const sizeAspectRatio = size.width / size.height;

  let width = target.width;
  let height = target.height;

  if (sizeAspectRatio > targetAspectRatio) {
    height = target.width / sizeAspectRatio;
  } else {
    width = target.height * sizeAspectRatio;
  }

  return { width, height };
};

export const aspectFit = (rect: Rect, target: Rect): Rect => {
  const targetAspectRatio = target.width / target.height;
  const rectAspectRatio = rect.width / rect.height;

  let width = target.width;
  let height = target.height;

  if (rectAspectRatio > targetAspectRatio) {
    height = target.width / rectAspectRatio;
  } else {
    width = target.height * rectAspectRatio;
  }

  return {
    x: target.x + (target.width - width) / 2,
    y: target.y + (target.height - height) / 2,
    width,
    height,
  };
};
